//正则实现首字母大字
export default function firstUpperCase(letter){
	if(typeof letter!=="string") return letter;
	return letter.replace(/\b(\w)(\w*)/g, function($0, $1, $2) {
        return $1.toUpperCase() + $2.toLowerCase();
    });
}
